import api from '../api';

export const addUpdateSearch = (data) => api.post('/core/functions/addUpdateSearch', data);

export const deleteSearch = (data) => api.post('/core/functions/deleteSearch', data);

export const fetchSavedSearches = () => api.post('/core/functions/fetchSavedSearches');
